export { ASSIGN_TO_PRODUCT } from './assignToProduct';
